import { combineReducers } from 'redux';

import data from './data';
import ui from './ui';

/**
 * @typedef {{
 *   data: import('./data').ContactMembersDataEntity,
 *   ui: import("./ui").ContactMembersUIReducer,
 * }} ContactMembersReducer
 */

export default combineReducers({
  data,
  ui
});
